const questionData = [
  {
    field: 'sex',
    field_title: '您的性别',
    index: 1,
    field_type: 'radio',
    field_unit: [
      {
        key: 'a',
        value: '男'
      },
      {
        key: 'b',
        value: '女'
      }
    ],
    value: '',
    data_type: '0',
    data_num: ''
  },
  {
    field: 'age',
    field_title: '你的年龄',
    index: 2,
    field_type: 'input',
    field_unit: [],
    value: '',
    data_type: '0',
    data_num: ''
  },
  {
    field: 'height',
    field_title: '你的身高',
    index: 3,
    field_type: 'input',
    field_unit: 'cm',
    value: '',
    data_type: '0',
    data_num: ''
  },
  {
    field: 'weight',
    field_title: '你的体重',
    index: 4,
    field_type: 'input',
    field_unit: 'kg',
    value: '',
    data_type: '0',
    data_num: ''
  },
  {
    field: 'nutritional_goal_weight',
    field_title: '你的目标体重',
    index: 5,
    field_type: 'input',
    field_unit: 'kg',
    value: '',
    data_type: '0',
    data_num: ''
  },
  {
    field: 'first_step',
    field_title: '早晨洗漱完毕后，你会做的第一件事是？',
    index: 6,
    field_type: 'radio',
    field_unit: [
      {
        key: 'a',
        value: '喝一大杯饮用水',
        score: 1
      },
      {
        key: 'b',
        value: '喝一杯黑咖啡',
        score: 0
      },
      {
        key: 'c',
        value: '来一碗粉面或一个面包',
        score: 0
      },
      {
        key: 'd',
        value: '喝杯牛奶、果汁或蜂蜜水',
        score: 0
      },
      {
        key: 'e',
        value: '什么都不吃',
        score: 0
      }
    ],
    value: '',
    data_type: '4',
    data_num: ''
  },
  {
    field: 'vegetables',
    field_title: '以下常见食物，你认为哪些是属于蔬菜类呢？',
    index: 7,
    field_type: 'checkbox',
    field_unit: [
      {
        key: 'a',
        value: '贝贝南瓜',
        score: 0
      },
      {
        key: 'b',
        value: '山药',
        score: 0
      },
      {
        key: 'c',
        value: '莲藕',
        score: 0
      },
      {
        key: 'd',
        value: '豌豆',
        score: 0
      },
      {
        key: 'e',
        value: '土豆',
        score: 0
      },
      {
        key: 'f',
        value: '黄豆芽',
        score: 1
      }
    ],
    value: '',
    data_type: '1',
    data_num: ''
  },
  {
    field: 'low_sugar_fruit',
    field_title: '以下常见水果，你认为哪些是属于低糖水果呢？',
    index: 8,
    field_type: 'checkbox',
    field_unit: [
      {
        key: 'a',
        value: '香蕉',
        score: 0
      },
      {
        key: 'b',
        value: '西瓜',
        score: 1
      },
      {
        key: 'c',
        value: '鲜枣',
        score: 0
      },
      {
        key: 'd',
        value: '火龙果',
        score: 0
      },
      {
        key: 'e',
        value: '百香果',
        score: 0
      }
    ],
    value: '',
    data_type: '1',
    data_num: ''
  },
  {
    field: 'lunch',
    field_title: '决定点一份美味的外卖作为午餐，你会选择？',
    index: 9,
    field_type: 'radio',
    field_unit: [
      {
        key: 'a',
        value: '双层芝士牛肉<br/>汉堡外卖',
        score: 0
      },
      {
        key: 'b',
        value: '麻辣拌外卖',
        score: 0
      },
      {
        key: 'c',
        value: '粉面/饺子外卖',
        score: 0
      },
      {
        key: 'd',
        value: '烧鸭饭外卖',
        score: 1
      },
      {
        key: 'e',
        value: '轻食外卖',
        score: 1
      },
      {
        key: 'f',
        value: '决定自己动手<br/>做份营养轻食',
        score: 1
      }
    ],
    value: '',
    data_type: '4',
    data_num: ''
  },
  {
    field: 'cake',
    field_title: '朋友准备了你平常最爱吃的蛋糕，这个时候你会？',
    index: 10,
    field_type: 'radio',
    field_unit: [
      {
        key: 'a',
        value: '控制自己不会吃',
        score: 1
      },
      {
        key: 'b',
        value: '克制自己只吃一点点',
        score: 0
      },
      {
        key: 'c',
        value: '真的太香了，忍不住我要吃',
        score: 0
      }
    ],
    value: '',
    data_type: '3',
    data_num: ''
  },
  {
    field: 'hot_pot',
    field_title: '大家来到了当地有名的火锅或烤肉店',
    index: 11,
    field_type: 'radio',
    field_unit: [
      {
        key: 'a',
        value: '合理选择火锅/烤肉食<br/>材，洗掉油汤，荤素搭配',
        score: 1
      },
      {
        key: 'b',
        value: '只点最爱吃的食<br/>材，但不吃米饭',
        score: 0
      },
      {
        key: 'c',
        value: '不仅点最爱吃的食<br/>材，还要吃碗米饭',
        score: 0
      },
      {
        key: 'd',
        value: '不仅要点最爱的食材<br/>和吃米饭，还要在饭<br/>后来杯奶茶或水果',
        score: 0
      },
      {
        key: 'e',
        value: '什么也不吃',
        score: 0
      }
    ],
    value: '',
    data_type: '4',
    data_num: ''
  },
  {
    field: 'leisure_time',
    field_title: '通常会选择怎样度过接下来的时间呢？',
    index: 12,
    field_type: 'radio',
    field_unit: [
      {
        key: 'a',
        value: '健身房走起',
        score: 1
      },
      {
        key: 'b',
        value: '居家适量运动',
        score: 1
      },
      {
        key: 'c',
        value: '小区楼下散散步',
        score: 0
      },
      {
        key: 'd',
        value: '不想动，躺平',
        score: 0
      }
    ],
    value: '',
    data_type: '5',
    data_num: ''
  },
  {
    field: 'hungry',
    field_title: '你突然感到饿/嘴馋的时候',
    index: 13,
    field_type: 'radio',
    field_unit: [
      {
        key: 'a',
        value: '吃几颗坚果或<br/>适量低糖水果',
        score: 1
      },
      {
        key: 'b',
        value: '巧克力、蛋糕、饼干之类的甜食',
        score: 0
      },
      {
        key: 'c',
        value: '猪肉脯、海苔、火腿肠、<br/>牛肉干之类的加工食品',
        score: 0
      },
      {
        key: 'd',
        value: '螺狮粉、麻辣烫、烧<br/>烤之类的重口味宵夜',
        score: 0
      },
      {
        key: 'e',
        value: '忍住不吃',
        score: 1
      }
    ],
    value: '',
    data_type: '3',
    data_num: ''
  },
  {
    field: 'motion',
    field_title: '你每周会愿意花多长时间在运动上？',
    index: 14,
    field_type: 'radio',
    field_unit: [
      {
        key: 'a',
        value: '一周1-2次',
        score: 1
      },
      {
        key: 'b',
        value: '一周3-4次',
        score: 1
      },
      {
        key: 'c',
        value: '基本每天都有运动',
        score: 1
      },
      {
        key: 'd',
        value: '基本不运动，能躺<br/>着绝不站着',
        score: 0
      }
    ],
    value: '',
    data_type: '5',
    data_num: ''
  }
]
const bannerData = [
  /* 16岁及以下 */
  {
    top: {
      bannerInfo: {
        image:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/6ad7ffd4e82c6dcebc925c360bae1b3e.png',
        route: {
          method: 'miniProgram',
          url: '/miniProgram?userName=gh_3da9370ac840&path=pages/image-page/index?url=https%3A%2F%2Fcdnvue.gymcity.com.cn%2Fbetterwe_1.0%2Fvue%2Fbbc0b625d60d1fd6ec798f8b21be6f75.png&title=添加K所长'
        }
      }
    },
    bottom: {
      bannerInfo: {
        image:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/44c948b3407d03d6ab334a2bc89bd6a2.png',
        route: {
          method: 'route',
          url: '/betterwe/vip'
        }
      }
    }
  },
  /* 16到20 */
  {
    top: {
      bannerInfo: {
        image:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/44c948b3407d03d6ab334a2bc89bd6a2.png',
        route: {
          method: 'route',
          url: '/betterwe/vip'
        }
      }
    }
  },
  /* 20以上 */
  {
    top: {
      bannerInfo: {
        bannerInfo: {
          image:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-fat-loss-method'
        }
      }
    },
    bottom: {
      bannerInfo: {
        image: '',
        url: ''
      },
      coachInfo: {
        url: '/miniProgram?userName=gh_3da9370ac840&path=page/home/index',
        image: ''
      }
    }
  }
]
export { questionData, bannerData }
